export function isErrorModel(obj: any | ErrorModel): obj is ErrorModel {
  return (
    obj !== null &&
    obj !== undefined &&
    '$schema' in obj &&
    obj['$schema'].endsWith('/ErrorModel.json')
  )
}

export interface ErrorDetail {
  message: string
  location: string
  value: object
}

export interface ErrorModel {
  title: string
  status: number
  detail: string
  instance: string
  type: string
  errors: ErrorDetail[]
}

export interface ErrorResponse {
  response: Response
  body: ErrorModel
}
